import { jsx as _jsx } from "react/jsx-runtime";
import MuiPaper from '@mui/material/Paper';
import * as React from 'react';
import { useFlexBoxProps } from '../box';
import { usePaletteColor } from '../theme';
import { withVersion } from '../utils';
const paperElevationShadows = {
    S: '0px 1px 2px 0px rgba(0, 0, 0, 0.04), 0px 1px 3px 0px rgba(0, 0, 0, 0.08)',
    M: '0px 2px 4px 0px rgba(0, 0, 0, 0.06), 0px 4px 6px 0px rgba(0, 0, 0, 0.05)',
    L: '0px 4px 6px 0px rgba(0, 0, 0, 0.05), 0px 10px 15px 0px rgba(0, 0, 0, 0.08)',
    XL: '0px 8px 10px 0px rgba(0, 0, 0, 0.04), 0px 20px 25px 0px rgba(0, 0, 0, 0.1)'
};
export const getPaperElevationShadow = (elevation) => elevation === 'none' ? 'none' : paperElevationShadows[elevation];
export const withPaperElevation = (slotProps, elevation) => {
    const applyElevation = (resolvedSlotProps = {}) => ({
        ...resolvedSlotProps,
        elevation: 0,
        sx: [
            {
                boxShadow: resolvedSlotProps.variant === 'outlined' ||
                    resolvedSlotProps.elevation === 0
                    ? 'none'
                    : getPaperElevationShadow(elevation)
            },
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            ...(Array.isArray(resolvedSlotProps.sx)
                ? resolvedSlotProps.sx
                : resolvedSlotProps.sx
                    ? [resolvedSlotProps.sx]
                    : [])
        ]
    });
    return typeof slotProps === 'function'
        ? (ownerState) => applyElevation(slotProps(ownerState))
        : applyElevation(slotProps);
};
const PaperImpl = React.forwardRef((props, ref) => {
    const { backgroundColor: _backgroundColor, width, height, elevation = 'M', variant, ...paperProps } = props;
    const isContainer = variant === 'container';
    const backgroundColor = usePaletteColor(_backgroundColor ?? 'background.paper');
    return (_jsx(MuiPaper, { ref: ref, ...paperProps, elevation: 0, variant: isContainer ? 'outlined' : variant, sx: {
            backgroundColor,
            width,
            height,
            boxShadow: variant === 'outlined' ||
                isContainer ||
                elevation === 'none'
                ? 'none'
                : getPaperElevationShadow(elevation),
            ...(isContainer && {
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0
            }),
            ...paperProps.sx
        } }));
});
export const Paper = withVersion(PaperImpl, '1.1.0');
export const FlexPaper = React.forwardRef((props, ref) => {
    const { gap, vAlign, hAlign, stretch, autoShrink, stack, ...paperProps } = props;
    const flexProps = useFlexBoxProps({
        autoShrink,
        gap,
        vAlign,
        hAlign,
        stretch,
        stack
    });
    return (_jsx(Paper, { ref: ref, ...paperProps, sx: {
            ...flexProps,
            ...paperProps.sx
        } }));
});
